import './connectivity-check.style.scss';
import React from 'react';
import {observer, inject, IReactComponent} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {ScreenLoader} from '../../components/screen-loader/screen-loader';
import {IConnectivityCheckStore} from './connectivity-check.stores';
import {IAppRootStore} from '../../app.root.store';
import ConnectivityLayout from './ConnectivityLayout';
import ConnectivityComponent from './Connectivity';

interface ConnectivityCheckViewProps {
    connectivityCheckStore: IConnectivityCheckStore;
    rootStore: IAppRootStore;
}

@observer
export class ConnectivityCheckViewComponent extends TechseeBaseComponent<ConnectivityCheckViewProps> {
    renderInternal(): JSX.Element {
        const store = this.props.connectivityCheckStore;

        if (!store) {
            return <ScreenLoader />;
        }

        return (
            <ConnectivityLayout controller={store.connectivityController}>
                <ConnectivityComponent
                    connectivityController={store.connectivityController}
                    connectivityControllerAngular={store.connectivityControllerAngular}
                />
            </ConnectivityLayout>
        );
    }
}

export const ConnectivityCheckView = inject(
    'rootStore',
    'connectivityCheckStore'
)(ConnectivityCheckViewComponent) as IReactComponent;
